/**
 * @namespace source.items
 */
import { map } from 'ramda';
import { toError } from '../private/parsers/error';
import { fromVideotoItem } from './mappers/item';
import { toItem as toPrivateItem } from '../private-site/mappers/item';
export function initItems(settings, http) {
  const defaultPaging = {
    page_size: 25,
    cursor: null
  };
  function list(siteToken, options) {
    const url = settings.apiUrl + "/v3/vod/gallery/items";
    const queryParams = {
      ...defaultPaging,
      ...options.paging
    };
    queryParams.page_size = Math.min(25, queryParams.page_size); // wix video limit is 25

    http.setRequestOptionsOnce({
      params: {
        site_token: siteToken
      }
    });
    return http.get(url, queryParams, {
      headers: options.headers || {}
    }).then(function (response) {
      response.paging = {
        cursor: response.data.cursor
      };
      return {
        ...response,
        data: (response.data.items || []).map(item => fromVideotoItem(item, siteToken))
      };
    }).catch(toError);
  }
  function search(folderId, query, options) {
    const {
      siteMediaToken
    } = options;
    const url = settings.apiUrl + "/v3/vod/gallery/search";
    const queryParams = {
      query,
      ...defaultPaging,
      ...options.paging
    };
    queryParams.page_size = Math.min(25, queryParams.page_size); // wix video limit is 25

    http.setRequestOptionsOnce({
      params: {
        site_token: siteMediaToken
      }
    });
    return http.get(url, queryParams, {
      headers: options.headers || {}
    }).then(function (response) {
      response.paging = {
        cursor: response.data.cursor
      };
      return {
        ...response,
        data: (response.data.items || []).map(item => fromVideotoItem(item, siteMediaToken))
      };
    }).catch(toError);
  }
  function exist(siteToken) {
    const url = settings.apiUrl + "/v3/vod/gallery/has/items";
    return http.get(url, {
      siteToken
    }).then(existResponse => {
      return existResponse.data && existResponse.data.has_items === true;
    });
  }
  function importToSite(items, siteToken, options) {
    if (options === void 0) {
      options = {};
    }
    const url = settings.apiUrl + "/v3/vod/files/import";
    const {
      src_site_id,
      src_site_token
    } = options;
    return http.post(url, {
      siteToken,
      ...(src_site_id ? {
        src_site_id
      } : {}),
      ...(src_site_token ? {
        src_site_token
      } : {}),
      files: map(item => ({
        item_id: item.item_id,
        file_name: item.file_name,
        ...(item.code_source ? {
          code_source: item.code_source
        } : {})
      }), items)
    }).then(response => ({
      ...response,
      data: map(item => toPrivateItem(item, settings), response.data)
    }));
  }
  return {
    search,
    list,
    importToSite,
    exist
  };
}